<ng-template #generic let-config="config">
    <div class="modal-header">
        <h2 class="modal-title">{{ config.header }}</h2>
    </div>
    <div *ngIf="config.body" class="modal-body">
        <ng-container *ngFor="let item of config.body">

            <p *ngIf="item.hasOwnProperty('classes')" [class]="item.classes">
              <span [innerHTML]="item.label"></span>
            </p>
            <div *ngIf="item.hasOwnProperty('options')">
              <label>
                <span>{{ item.label }}</span>
              </label>
              <select  (change)="onChange(item.returnValue, $event.target.value)">
                <option *ngFor="let item of item.options | keyvalue" [value]="item.key">
                  {{item.value}}
                </option>
              </select>

            </div>


        </ng-container>
    </div>

    <div class="modal-footer mt-4">
        <ng-container *ngFor="let action of config.actions">
            <button
                type="button"
                class="btn btn-md"
                [ngClass]="[action.actionClass]"
                (click)="close(action.actionCallback)"
            >
                {{ action.label }}
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #uploadFile let-config="config">
    <div class="modal-header">
        <h2 class="modal-title">{{ config.header }}</h2>
    </div>
    <div *ngIf="config.body" class="modal-body">
        <ng-container *ngFor="let text of config.body">
            <p [class]="text.classes">{{ text.label }}</p>
        </ng-container>
        <p class="text-center border border-dark">
            <label class="my-2" for="actual-btn">Επιλογή Αρχείου</label>
        </p>
    </div>
    <div class="modal-footer">
        <ng-container *ngFor="let action of config.actions">
            <button
                type="button"
                class="btn btn-lg"
                [ngClass]="[action.actionClass]"
                (click)="close(action.actionCallback)"
            >
                {{ action.label }}
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #image let-config="config">
    <div class="modal-header">
        <h4 class="modal-title">{{ config.header }}</h4>
    </div>
    <div class="modal-body">
        <div class="imagepreview">
            <span>Φωτογραφία Προσώπου</span>
            <div class="imageuploaderpreview">
                <div class="imageuploaderpreview-placeholder">
                    <img
                        [src]="config.body.image.profile"
                        alt="Preview"
                        class="imageuploaderpreview-preview"
                    />
                </div>
            </div>
        </div>
        <div class="imagepreview">
            <span>Φωτογραφία Υπογραφής</span>
            <div class="imageuploaderpreview">
                <div class="imageuploaderpreview-placeholder">
                    <img
                        [src]="config.body.image.signature"
                        alt="Preview"
                        class="imageuploaderpreview-preview"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <ng-container *ngFor="let action of config.actions">
            <button
                type="button"
                class="btn btn-lg"
                [ngClass]="[action.actionClass]"
                (click)="close(action.actionCallback)"
            >
                {{ action.label }}
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #otp let-config="config">
    <div class="modal-header">
        <h4 class="modal-title">{{ config.header }}</h4>
    </div>
    <!-- <div class="modal-body">
    <p>test</p>
  </div> -->
    <div class="modal-footer">
        <ng-container *ngFor="let action of config.actions">
            <button
                type="button"
                class="btn btn-lg"
                [ngClass]="[action.actionClass]"
                (click)="close(action.actionCallback)"
            >
                {{ action.label }}
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-container [ngSwitch]="config.type">
    <ng-container *ngSwitchCase="'IMAGE'">
        <ng-container *ngTemplateOutlet="image; context: { config: config }">
        </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'OTP'">
        <ng-container *ngTemplateOutlet="otp; context: { config: config }">
        </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'UPLOAD'">
        <ng-container
            *ngTemplateOutlet="uploadFile; context: { config: config }"
        >
        </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="generic; context: { config: config }">
        </ng-container>
    </ng-container>
</ng-container>
